'use client';

import React from 'react';

interface OperationBadgeProps {
  type: string;
}

const typeStyles: Record<string, string> = {
  Buy: 'bg-pink-100 text-pink-600',
  Sell: 'bg-[#0f1f4b] text-white',
  Exchange: 'bg-yellow-100 text-yellow-600',
};

export const OperationBadge: React.FC<OperationBadgeProps> = ({ type }) => {
  const badgeClass = typeStyles[type] ?? 'bg-gray-100 text-gray-600';

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold ${badgeClass}`}
    >
      {type}
    </span>
  );
};
